<template>
    <v-card color="transparent" flat class="card--info" :class="{'card--info-mobile': !isDesktop}" tile>
        <section-header :title="title" :action="action" :small="true" class="pr-0"></section-header>
        <div class="card--info-scroll-target card--info-scroll-target-horizontal" data-target="contained">
            <div class="card--info-content" data-content="scrollable">
                <v-container fluid class="py-0">
                    <v-row class="ma-0" dense>
                        <slot></slot>
                    </v-row>
                </v-container>
            </div>
        </div>
    </v-card>
</template>
<script>
import infiniteScrollMixin from "@/mixins/mixin-infinite-scroll"
export default {
    mixins: [infiniteScrollMixin],
    
    props: ['title', 'action'],

    mounted() {
        this.$nextTick(() => {
            const scrollTarget = this.$el.querySelector('.card--info-scroll-target')
            scrollTarget.addEventListener('scroll', this.onScrollX, false)
        })
    },

    destroyed() {
        const scrollTarget = this.$el.querySelector('.card--info-scroll-target')
        scrollTarget.removeEventListener('scroll', this.onScrollX, false)
    },

    methods: {
        onReachScrollRight(val) {

            if (val) {
                this.$emit('scrolledTillRight', true)
            } else {
                this.$emit('scrolledTillRight', false)
            }

        }
    }
}
</script>